import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import Checkbox from "~/common/components/Checkbox";
import Form from "~/common/components/Form";
import { API_STATE } from "~/common/constants/state";
import useRequest from "~/common/hooks/useRequest";
import { findPropertyValue } from "~/utils/object";
import { SearchIcon } from "~/assets/svg/InterfaceIcon";
import { useTranslation, Trans } from "react-i18next";
import { useGlobalStore } from "~/store";
import DarkDefaultProfileImg from "~/assets/img/defaultImg/dark-profile-large2.png";
import LightDefaultProfileImg from "~/assets/img/defaultImg/light-profile-large.png";

const UserRow = ({ onChange, option, checked }) => {
	const { t } = useTranslation();
	const [
		{
			theme: { theme },
		},
	] = useGlobalStore();
	return (
		<div className="tr">
			<div className="td mem-check">
				<label className="checkbox-custom checkbox">
					<input
						type="checkbox"
						checked={checked}
						onChange={(e) => onChange(e)}
						value={option.value}
					/>
					<span className="checkmark" />
				</label>
			</div>
			<div className="td mem-name">
				<div className="img-wrap">
					<img
						src={
							option.img ??
							(theme === "dark" ? DarkDefaultProfileImg : LightDefaultProfileImg)
						}
						alt={t("pages.vcInfo.VcMember.Edit.Modal.profile")}
					/>
				</div>
				{option.label}
			</div>
			<div className="td mem-group">{option.department ?? "-"}</div>
			<div className="td mem-email">{option.id ?? "-"}</div>
		</div>
	);
};

const Modal = ({ setModalToggle, importUser }) => {
	const teamMemberRequest = useRequest("get", "vc/admin/invite");

	const [isAllChecked, setIsAllCheck] = useState(false);

	const [allCheck, setAllCheck] = useState(false);

	useEffect(() => {
		setAllCheck(isAllChecked);
	}, [isAllChecked]);

	useEffect(() => {
		teamMemberRequest.singleCall();
	}, []);

	const mappedData = teamMemberRequest.response?.data?.map((data) => ({
		label: data.name,
		value: data.idx,
		position: data.position,
		department: data.department,
		introduction: data.introduction,
		img: data.img,
		id: data.id,
	}));

	const [response, setResponse] = useState([]);

	useEffect(() => {
		switch (teamMemberRequest.state) {
			case API_STATE.done:
				setResponse(mappedData);
				break;
			default:
				break;
		}
	}, [teamMemberRequest.state]);

	const userListForm = useForm();

	const closeModal = () => {
		setModalToggle(false);
	};

	const handleClick = (data) => {
		const selectedUsers = mappedData.filter((user) =>
			data.list.includes(user.value.toString())
		);

		const newUsers = selectedUsers.map((user) => ({
			name: user.label,
			position: user.position,
			department: user.department,
			introduction: user.introduction,
			img: user.img,
			id: user.id,
		}));
		importUser(newUsers);
		closeModal();
	};

	const { t } = useTranslation();

	const nums = response.length;

	return (
		<>
			<div className="modal-content">
				<div className="table-top">
					<div className="mem-total">
						<Trans
							i18nKey="pages.vcInfo.VcMember.Edit.Modal.memberLength"
							components={[{ nums }]}
						/>
					</div>
					<div className="c__search">
						<input
							className="c__input"
							placeholder={t("pages.vcInfo.VcMember.Edit.Modal.inputMemberInfo")}
							onChange={({ target }) => {
								setResponse(findPropertyValue(mappedData, target.value));
							}}
						/>
						<button type="button" className="btn-search">
							<SearchIcon />
						</button>
					</div>
				</div>
				<div className="c__table teamInfo-table">
					<div className="thead">
						<div className="tr">
							<label className={`th mem-check checkbox-custom`}>
								<input
									type="checkbox"
									checked={allCheck}
									onChange={() => setIsAllCheck(!isAllChecked)}
								/>
								<span className="checkmark" />
							</label>
							<div className="th mem-name">
								{t("pages.vcInfo.VcMember.Edit.Modal.name")}
							</div>
							<div className="th mem-group">
								{t("pages.vcInfo.VcMember.Edit.Modal.depart")}
							</div>
							<div className="th mem-email">
								{t("pages.vcInfo.VcMember.Edit.Modal.mail")}
							</div>
						</div>
					</div>
					<div className="tbody">
						<Form useForm={userListForm}>
							<Checkbox
								name="list"
								options={response}
								isAllChecked={isAllChecked}
								setAllCheck={setAllCheck}
								setAllSelected={setIsAllCheck}
							>
								<UserRow />
							</Checkbox>
						</Form>
					</div>
				</div>
			</div>
			<div className="modal-footer">
				<button onClick={closeModal} className="btn__solid" color="gray" key="cancel">
					{t("pages.vcInfo.VcMember.Edit.Modal.cancel")}
				</button>
				<button
					onClick={userListForm.handleSubmit(handleClick)}
					className="btn__solid"
					color="primary"
					key="submit"
				>
					{t("pages.vcInfo.VcMember.Edit.Modal.load")}
				</button>
			</div>
		</>
	);
};

export default Modal;
